import { message } from "antd";
import {
  MODULE_ACCESS_DENIED_MESSAGE,
  SESSION_EXPIRED_MESSAGE,
} from "../common/apiResponse";
import { clearAuthSession } from "../common/localStorage";

const LOGIN_ROUTE = "/";

let navigateCallback = null;
let sessionResetCallback = null;
let cachedDefaultRoute = "/";
let forbiddenNavigationCooldownUntil = 0;
let unauthorizedSessionCooldownUntil = 0;
const FORBIDDEN_NAV_COOLDOWN_MS = 2500;

export const registerForbiddenNavigation = (navigate) => {
  navigateCallback = navigate ?? null;
};

export const registerSessionReset = (callback) => {
  sessionResetCallback = callback ?? null;
};

export const setForbiddenDefaultRoute = (route) => {
  cachedDefaultRoute = route || "/";
};

export const getDefaultRouteFromStore = () => cachedDefaultRoute;

const navigateWithFallback = (route) => {
  if (navigateCallback) {
    navigateCallback(route, { replace: true });
    return;
  }

  window.location.replace(route);
};

export const navigateToDefaultRoute = () => {
  if (Date.now() < forbiddenNavigationCooldownUntil) {
    return;
  }

  forbiddenNavigationCooldownUntil = Date.now() + FORBIDDEN_NAV_COOLDOWN_MS;

  const defaultRoute = cachedDefaultRoute || "/";
  navigateWithFallback(defaultRoute);
};

export const handleUnauthorizedSession = (errorMessage) => {
  if (Date.now() < unauthorizedSessionCooldownUntil) {
    return;
  }

  unauthorizedSessionCooldownUntil = Date.now() + FORBIDDEN_NAV_COOLDOWN_MS;

  message.warning({
    content: errorMessage || SESSION_EXPIRED_MESSAGE,
    key: "unauthorized-session",
  });

  clearAuthSession();
  sessionResetCallback?.();
  navigateWithFallback(LOGIN_ROUTE);
};

export const handleForbiddenApiAccess = (errorMessage) => {
  message.warning({
    content: errorMessage || MODULE_ACCESS_DENIED_MESSAGE,
    key: "forbidden-access",
  });
  navigateToDefaultRoute();
};
